import { T2Code, T2CodeLite } from '@lockton-apps/shared/interfaces';

export const t2CodeLite = ({ id, name }: T2Code): T2CodeLite => ({ id, name });
